import { useQuery } from 'react-query';
import { useEffect } from 'react';
import { queryClient } from '../../../../../../config/queryClient';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { queryKeys } from '../../api/queryKeys';
import { openPopupWindow } from '../../utils/openPopupWindow';

let wealthBoxOauthInterval;

export const useWealthbox = () => {
  const queryInfo = useQuery(
    queryKeys.Wealthbox(),

    () => authFetch('/Adviser/Wealthbox/OAuthConnect'),
    {
      enabled: false,
    },
  );

  const { refetch } = queryInfo;

  useEffect(() => {
    return () => {
      clearInterval(wealthBoxOauthInterval);
    };
  }, []);

  const connectWealthbox = async () => {
    try {
      const { data, error } = await refetch();

      const oAuthWindow = openPopupWindow(data?.url);

      const longPoolPopupWindow = async () => {
        if (!oAuthWindow || oAuthWindow.closed) {
          clearInterval(wealthBoxOauthInterval);
          wealthBoxOauthInterval = null;

          if (!error) {
            queryClient.invalidateQueries(queryKeys.integrations());
          }
        }
      };

      if (wealthBoxOauthInterval == null) {
        wealthBoxOauthInterval = window.setInterval(longPoolPopupWindow, 300);
      }
    } catch (err) {
      console.error('Error connecting to Wealthbox:', err);
    }
  };

  return {
    ...queryInfo,
    connectWealthbox,
  };
};
